import CommonAPIService from './CommonHandler';

export class SessionsAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  getActiveSessions(router) {
    const orders = 'username';
    const url = `/api/sessions/active?orders=${orders}`;
    return this.CommonAPIService.getCall(url, router);
  }

  /**
   @param {string} username the user username
   @param {date | null} startDate looks for sessions from the starting date.
   @param {date | null} endtDate looks for sessions to the end date.
   @param {number | null} type the session numeric type. for more info check -> https://dominioninsurance.atlassian.net/wiki/spaces/SA/pages/1544650753/Sessions+type+names+and+values
   @param {number} page used for pagination, default is 1.
   */
  getLogsUserSessions(username, startDate = null, endDate = null, type = null, page = 1, router) {
    const orderBy = 'username,login';
    const directions = 'ASC,ASC';
    const limit = 1000;
    let url = `/api/sessions?action=log&username=${username}&orderBy=${orderBy}&directions=${directions}&page=${page}&limit=${limit}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;
    if (type) url += `&type=${type}`;
    return this.CommonAPIService.getCall(url, router);
  }

  /**
   @param {string} username the user username
   @param {date | null} startDate looks for sessions from the starting date.
   @param {date | null} endtDate looks for sessions to the end date.
   @param {number | null} type the session numeric type. for more info check -> https://dominioninsurance.atlassian.net/wiki/spaces/SA/pages/1544650753/Sessions+type+names+and+values
   */
  getDailyUserSessions(username, startDate = null, endDate = null, type = null, router) {
    let url = `/api/sessions?action=daily&username=${username}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;
    if (type) url += `&type=${type}`;
    return this.CommonAPIService.getCall(url, router);
  }

  /**
   @param {string} username the user username
   @param {date | null} startDate looks for sessions from the starting date.
   @param {date | null} endtDate looks for sessions to the end date.
   @param {number | null} type the session numeric type. for more info check -> https://dominioninsurance.atlassian.net/wiki/spaces/SA/pages/1544650753/Sessions+type+names+and+values
   */
  getPeriodUserSessions(username, startDate = null, endDate = null, type = null, router) {
    let url = `/api/sessions?action=period&username=${username}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;
    if (type) url += `&type=${type}`;
    return this.CommonAPIService.getCall(url, router);
  }

  getSessionById(id, router) {
    // 29 Jan 2026 JCH Prefer direct GET by UUID, fall back to legacy log lookup if needed
    if (typeof id === 'string' && id.length > 10) {
      return this.CommonAPIService.getCall(`/api/sessions/${id}`, router)
        .catch((error) => {
          const url = `/api/sessions?action=log&id=${encodeURIComponent(id)}&limit=1`;
          return this.CommonAPIService.getCall(url, router)
            .then(response => {
              const sessions = response.logs || response;
              if (sessions?.length > 0) {
                const session = sessions[0];
                // Use numeric primary_key for single GET if available
                return session.primary_key
                  ? this.CommonAPIService.getCall(`/api/sessions/${session.primary_key}`, router)
                  : session;
              }
              throw new Error(`Session with UUID ${id} not found`);
            })
            .catch(() => { throw error; });
        });
    }
    // Numeric ID - use path parameter
    return this.CommonAPIService.getCall(`/api/sessions/${id}`, router);
  }

  createSession(body, router) {
    const url = `/api/sessions`;
    return this.CommonAPIService.postCall(url, body, router);
  }

  updateSession(id, body, router) {
    if (typeof id === 'string' && id.length > 10) {
      // 29 Jan 2026 JCH Try PUT by UUID first, fall back to primary_key for older backends
      return this.CommonAPIService.putCall(`/api/sessions/${id}`, body, router)
        .catch(() => this.getSessionById(id, router)
          .then(session => {
            const numericId = session.primary_key; // Extract numeric ID from primary_key field
            const url = `/api/sessions/${numericId}`; // Use numeric ID for backend API
            return this.CommonAPIService.putCall(url, body, router);
          }));
    }
    const url = `/api/sessions/${id}`; // Already numeric - use directly
    return this.CommonAPIService.putCall(url, body, router);
  }

  deleteSession(id, router) {
    const numericId = parseInt(id, 10);
    const url = `/api/sessions/${numericId}`;
    return this.CommonAPIService.deleteCall(url, router);
  }
}

export default SessionsAPIService;
